(function() {
    'use strict';

    var ListPermissionCtrl = function($scope, ajaxCall) {

        console.log("Inside ListPermissionCtrl");
        $scope.listPermModel = {};
        $scope.listPermModel.showLoader = false;
        $scope.listPermModel.disableBtn = false;
        $scope.listPermModel.usersInTable = [];
        $scope.listPermModel.messageType = 'success';


        var ajaxCallList = function(ajaxUrl, data) {
            var errorMsg = 'Error';
            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    $scope.listPermModel.showLoader = false;
                    $scope.listPermModel.disableBtn = false;
                    $scope.listPermModel.messagePerm = result.data;
                    $scope.listPermModel.messageType = 'success'
                },
                function(result) {
                    $scope.listPermModel.showLoader = false;
                    $scope.listPermModel.disableBtn = false;
                    $scope.listPermModel.messagePerm = errorMsg;
                }
            );
        }

        $scope.deletePermissionBulkNg = function($event) {
            $event.preventDefault();
            $scope.listPermModel.showLoader = true;
            $scope.listPermModel.disableBtn = true;
            var tagIdPop = $scope.listPermModel.tagIdPop;

            if (tagIdPop) {
                var data = 'tagId=' + tagIdPop;
                var ajaxUrl = WEBAPP_PATH + "/tagAdmin/deletePermissions?";
                var errorMsg = 'Error';
            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    $scope.listPermModel.tableModel = [];
                    $scope.listPermModel.tableBranchModel = [];
                    $scope.listPermModel.tableModel.userOptions = $scope.listPermModel.userOptions;
                    $scope.listPermModel.tableModel.userRightsOptions = $scope.listPermModel.userRightsOptions;
                    $scope.listPermModel.tableBranchModel.orgUnitsJson = $scope.listPermModel.orgUnitsJson;
                    $scope.listPermModel.tableBranchModel.userRightsOptions = $scope.listPermModel.userRightsOptions;
                    $scope.listPermModel.messagePerm = result.data;
                    $scope.listPermModel.messageType = 'success'
                    $scope.listPermModel.showLoader = false;
                    $scope.listPermModel.disableBtn = false;
                },
                function(result) {
                    $scope.listPermModel.showLoader = false;
                    $scope.listPermModel.disableBtn = false;
                    $scope.listPermModel.messagePerm = errorMsg;
                }
            );
            }
            return false;
        }

        $scope.cancel = function() {
             $scope.ok();
        };

        $scope.tagPermissionSubmitNg = function($event) {

            $event.preventDefault();

            var usersInTable = []

            var userPermissionArray = [];
            var index = 0;
            var tableData;
            var tableModel = $scope.listPermModel.tableModel;
            var tagIdPop = $scope.listPermModel.tagIdPop;
            if($scope.formTS.otherUserAccessTableForm.$valid){
                for(i=0;i<tableModel.length;i++){
                    tableData = tableModel[i];
                    if(usersInTable.length > 0 && usersInTable.includes(tableData.userSelect.xmsLoginId)){
                        $scope.listPermModel.messagePerm =  "The action cannot be saved as multiple rows have the same user id."
                        $scope.listPermModel.messageType = 'danger'
                        return false;
                    }else{
                    var userPermissionMap = {};
                    userPermissionMap['userId'] = tableData.userSelect.xmsLoginId;
                    userPermissionMap['userRightId'] = tableData.userRightsSelect.id;
                    userPermissionArray[i] = userPermissionMap;
                    usersInTable.push(tableData.userSelect.xmsLoginId);
                    }
                }
            }

            var OUsInTable = []

            var ouPermissionArray = [];
            index = 0;
            var tableBranchModel = $scope.listPermModel.tableBranchModel;
            if($scope.formTS.wholeBranchAccessTableForm.$valid){
                for(i=0;i<tableBranchModel.length;i++){
                    tableData = tableBranchModel[i];
                    if(OUsInTable.length > 0 && OUsInTable.includes(tableData.orgUnitSelect.id)){
                        $scope.listPermModel.messagePerm =  "The action cannot be saved as multiple rows have the same OU id."
                        $scope.listPermModel.messageType = 'danger'
                        return false;
                    }else{
                    var ouPermissionMap = {};
                    ouPermissionMap['ouId'] = tableData.orgUnitSelect.id;
                    ouPermissionMap['ouRightId'] = tableData.userRightsSelect.id;
                    ouPermissionArray[i] = ouPermissionMap;
                    OUsInTable.push(tableData.orgUnitSelect.id);
                    }
                }
            }
            var userOwner = $scope.listPermModel.userOwner;

            var data = 'userPermissionArray=' + angular.toJson(userPermissionArray) + '&ouPermissionArray=' + angular.toJson(ouPermissionArray);
            data = data + '&userOwner=' + userOwner + '&tagId=' +tagIdPop;

            var ajaxUrl = WEBAPP_PATH + "/tagAdmin/updatePermissionsAll";
            ajaxCallList(ajaxUrl , data);

            return false;
        }

    }
    ListPermissionCtrl.$inject = ['$scope', 'ajaxCall'];
    angular.module('app').controller('ListPermissionCtrl', ListPermissionCtrl);

}());
